import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import Loader from '../../../components/Loader/Loader';
import Button from '../../../components/Button/CustomButton';
import {
    LoadMoreIcon,
} from '../../../components/Icons/Icon';
import ConfirmDialog from '../../../components/Dialog/ConfirmDialog';

const useStyles = makeStyles(() => ({
    container: {
        direction: 'row',
        justify: 'space-between',
        alignItems: 'stretch',
        textAlign: 'center',
    },
    items: {
        '& img': {
            height: 200,
            width: 200,
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            objectFit: 'contain',
            cursor: 'pointer',
        },
        '& p': {
            marginBottom: 40,
            wordBreak: 'break-word',
        },
    },
}));

const CompanyEventManagement = ({
    fetchListCompanyEvent,
    fetchClearListCompanyEvent,
    companyEventData,
    listCompanyEvent,
    isLoading,
    eventInfo,
}) => {
    const classes = useStyles();
    const history = useHistory();
    const params = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [isOpenConfirmSuccess, setIsOpenConfirmSuccess] = useState({ open: false, content: '' });

    const useQuery = () => new URLSearchParams(useLocation().search).has('payment');

    const query = useQuery();

    useEffect(() => {
        if (!_.isEmpty(params.shortName)) {
            fetchListCompanyEvent({
                event_name: params.shortName,
            });
        }
        return () => fetchClearListCompanyEvent();
    }, [params.shortName]);

    useEffect(() => {
        if (!_.isEmpty(eventInfo)) {
            if (query && eventInfo.has_shopping_cart && !eventInfo.has_credit_payment && !eventInfo.has_bank_payment) {
                setIsOpenConfirmSuccess({ open: true, content: 'ショッピングカートを設定する必要があります。' });
            }
        }
    }, [eventInfo]);

    useEffect(() => {
        if (companyEventData.total_length > 0) {
            setCurrentPage(companyEventData.page);
            setTotalPage(companyEventData.total_page);
        }
    }, [companyEventData]);

    const handleShowDetailCompany = (idCompany) => {
        history.push(`/admin/${params.shortName}/${idCompany}/company-detail`);
    };

    const handleLoadMore = () => {
        fetchListCompanyEvent({ event_name: params.shortName, page: currentPage + 1 });
    };

    const listCompany = () => listCompanyEvent.map((items) => (
        <GridItem md={3} className={classes.items} key={items.id} onClick={() => handleShowDetailCompany(items.id)}>
            <img className={classes.img} src={items.image ? items.image : '/resources/No_image_found.jpg'} alt={items.short_name} />
            <p>{items.full_name}</p>
        </GridItem>
    ));

    const handleSuccessDialog = () => {
        history.push(`/admin/${params.shortName}/shopping-cart`);
    };

    return (
        <>
            <GridContainer className={classes.container}>
                {companyEventData.total_length > 0 ? (
                    <>
                        {listCompany()}
                        { currentPage < totalPage && (
                            <GridItem align="center">
                                <Button
                                    onClick={handleLoadMore}
                                    color="info"
                                    gradient
                                    size="md"
                                    round
                                >
                                    <LoadMoreIcon />
                                    もっと見る
                                </Button>
                            </GridItem>
                        )}
                    </>
                ) : (
                    <GridItem
                        xs={12}
                        style={{
                            textAlign: 'center', fontWeight: 'bold', fontSize: '20px', zIndex: 1,
                        }}
                    >
                        <FormattedMessage id="noData" />
                    </GridItem>
                )}
            </GridContainer>
            <ConfirmDialog
                title="確認ダイアログ"
                contents={isOpenConfirmSuccess.content}
                open={isOpenConfirmSuccess.open}
                handleClose={handleSuccessDialog}
            />
            <Loader isLoading={isLoading} />
        </>
    );
};

CompanyEventManagement.defaultProps = {
    companyEventData: {},
    listCompanyEvent: [],
    eventInfo: {},
};

CompanyEventManagement.propTypes = {
    fetchListCompanyEvent: PropTypes.func.isRequired,
    fetchClearListCompanyEvent: PropTypes.func.isRequired,
    companyEventData: PropTypes.oneOfType([() => null, PropTypes.object]),
    listCompanyEvent: PropTypes.oneOfType([() => null, PropTypes.array]),
    isLoading: PropTypes.bool.isRequired,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default CompanyEventManagement;
